import React from 'react';

function TermsPopup({ isPopup, setIsPopup, title, content }) {
    if (!isPopup) return null;

    return (
        <div className="popup_overlay" onClick={() => setIsPopup(false)}>
            <div className="popup_container_terms" onClick={(e) => e.stopPropagation()}>
                <div className="popup_header">
                <h3>{title}</h3>
                <button 
                    type="button" 
                    className="popup_close_btn"
                    onClick={() => setIsPopup(false)}
                >
                    ×
                </button>
                </div>
                <div className="popup_content">
                <div dangerouslySetInnerHTML={{ __html: content }} />
                </div>
            </div>
            </div>
        );
    }

export default TermsPopup;